/* ADMIN AUTH */

import Basic from '@/views/layouts/basic.vue';
import Roles from '@/views/auth/admin/roles/list.vue';
import Role from '@/views/auth/admin/roles/details.vue';
import RolePrivileges from '@/views/auth/admin/roles/privileges/list.vue';
import RolePrivilegesEdit from '@/views/auth/admin/roles/privileges/details.vue';
import AdminUsers from '@/views/auth/admin/users/list.vue';
import AdminUser from '@/views/auth/admin/users/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'auth/admin',
  name: 'auth.admin',
  meta: {title: 'Admin'},
  redirect: '/auth/admin/gebruikers',
  component: Basic,
  children: [
    // ROLES
    {
      path: 'rollen',
      name: 'auth.admin.roles',
      meta: {title: 'Admin'},
      component: Roles,
    },
    {
      path: 'rol/:id/wijzigen',
      name: 'auth.admin.role.edit',
      meta: {title: 'Admin'},
      component: Role,
    },
    {
      path: 'rol/toevoegen',
      name: 'auth.admin.role.add',
      meta: {title: 'Admin'},
      component: Role,
    },
    {
      path: 'rol/:id/privileges',
      name: 'auth.admin.role.privileges',
      meta: {title: 'Admin'},
      component: RolePrivileges,
    },
    {
      path: 'rol/:id/privileges/wijzigen',
      name: 'auth.admin.role.privileges.edit',
      meta: {title: 'Admin'},
      component: RolePrivilegesEdit,
    },
    // USERS
    {
      path: 'gebruikers',
      name: 'auth.admin.users',
      meta: {title: 'Admin'},
      component: AdminUsers,
    },
    {
      path: 'gebruiker/:id/wijzigen',
      name: 'auth.admin.user.edit',
      meta: {title: 'Admin'},
      component: AdminUser,
    },
  ],
};
